import {AfterViewInit, Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MomentService, UiConfigService} from '@lv1871/core';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {merge, switchMap} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Kunde, Kundensuche} from '../../../models/kundensuche';

@Component({
    selector: 'lv-kunden-treffer-dialog',
    templateUrl: './kunden-treffer-dialog.component.html',
    styleUrls: ['./kunden-treffer-dialog.component.scss'],
    standalone: false
})
export class KundenTrefferDialogComponent implements AfterViewInit {

  @ViewChild(MatSort)
  sort: MatSort;
  @ViewChild(MatPaginator)
  paginator: MatPaginator;

  public displayedColumns: string[] = ['kundennummer', 'vorname', 'name', 'geburtsdatum', 'strasse', 'ort', 'uebernehmen'];
  public dataSource: Kunde[];
  public isLoading = false;

  constructor(public dialogRef: MatDialogRef<KundenTrefferDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Kundensuche,
              private _momentService: MomentService, private _http: HttpClient, private _configService: UiConfigService) {
    this.dataSource = this._getKundenFromData();
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

      merge(this.sort.sortChange, this.paginator.page).pipe(
          switchMap(() => {
            this.isLoading = true;
            return this._http.post<Kundensuche>(
                this._configService.getAntragserfassungUrl() + '/api/produkt/kundensuche/' + this.data.identifikator, {
                  vorgang: this.data.vorgang,
                  pageIndex: this.paginator.pageIndex,
                  elementsPerPage: 12,
                  sort: this.sort.active ? {
                    column: this.sort.active,
                    direction: this.sort.direction
                  } : undefined
                });
          })
      )
          .subscribe(data => {
            this.isLoading = false;
            data.identifikator = this.data.identifikator;
            data.vorgang = this.data.vorgang;
            this.data = data;
            this.dataSource = this._getKundenFromData();
          });
    }

  }

  public formatDate(geburtsdatum: string) {
    if (!geburtsdatum) {
      return '';
    }
    return this._momentService.moment(geburtsdatum, 'YYYY-MM-DD', true)?.format('DD.MM.YYYY');
  }

  public selectKunde(kunde: Kunde) {
    this.dialogRef.close(kunde.knr);
  }

  public getSearchParams(): string {
    const keyBlacklist = ['type', 'page', 'sort', 'size'];
    return Object.keys(this.data.searchParams).filter(key => !keyBlacklist.includes(key)).map(key => '<strong>' + this._titleCaseText(key) + '</strong>: ' + this.data.searchParams[key]).join(', ');
  }

  public closeDialog() {
    this.dialogRef.close(undefined);
  }

  private _titleCaseText(text: string) {
    if (!text) {
      return text;
    }
    return text[0].toUpperCase() + text.substr(1).toLowerCase();
  }

  private _getKundenFromData(): Kunde[] {
    return this.data.content.map(kunde => ({
      knr: kunde.knr,
      vorname: kunde.vorname,
      name: kunde.name,
      geburtsdatum: kunde.geburtsdatum,
      strasse: kunde.meldeadresse?.strasse,
      hausnummer: kunde.meldeadresse?.hausnummer,
      postleitzahl: kunde.meldeadresse?.postleitzahl,
      ort: kunde.meldeadresse?.ort
    } as Kunde)) as Kunde[];
  }
}
